// @flow

import React from "react";
import moment from "moment";
import {
  navigateToRouteHelper,
  getFormattedSLAFromMillis,
  getFormattedDateAndTime
} from "../../../../services/helpers";

import styles from "./ticketDashboard.scss";

export const ticketDashboardRouteObject = {
  route: `/ticketdashboard`,
  zoomuinewroute: true,
  pageName: "Pace Dashboard"
};

export const isAuthorized = (userProfile: Object, rolesToCheck: Object) => {
  let isAuthorizedVar = false;
  if (rolesToCheck && rolesToCheck.length) {
    rolesToCheck.forEach(role => {
      if (userProfile && userProfile.authorities.indexOf(role) !== -1) {
        isAuthorizedVar = true;
      }
    });
  } else {
    // No role authentication present
    isAuthorizedVar = true;
  }
  return isAuthorizedVar;
};

export const getSettingsOptions = userProfile => {
  const arrayToReturn = [];
  if (
    isAuthorized(userProfile, [
      "ROLE_EDIT_TICKET_CE",
      "ROLE_MANAGE_BUSINESS_UNIT",
      "ROLE_MANAGE_CATEGORY"
    ])
  ) {
    arrayToReturn.push({
      value: "buSettings",
      label: "Business unit Settings"
    });
  }
  if (
    isAuthorized(userProfile, [
      "ROLE_EDIT_TICKET_CE",
      "ROLE_EDIT_TICKET_CE",
      "ROLE_MANAGE_CATEGORY"
    ])
  ) {
    arrayToReturn.push({
      value: "categorySettings",
      label: "Category Settings"
    });
  }
  if (
    isAuthorized(userProfile, [
      "ROLE_EDIT_TICKET",
      "ROLE_MANAGE_RESOLVER_GROUP"
    ])
  ) {
    arrayToReturn.push({
      value: "resolverGroupSettings",
      label: "Resolver group Settings"
    });
  }
  return arrayToReturn;
};

const goToViewTicket = (rowData: Object) => {
  // eslint-disable-next-line no-console
  console.log("history", rowData);
  if (!rowData || !rowData.id) {
    return;
  }
  const viewTicketRouteObj = {
    route: `/viewticket/${rowData.id}`,
    zoomuinewroute: true
  };

  navigateToRouteHelper(viewTicketRouteObj, true);
};

const getTicketDashboardCellObject = (
  dataUp: string,
  dataDown: string,
  rowData: Object,
  clickHandler1: Function,
  customClass1,
  customClass2
) => (
  <div className="flex-100 table-cell-custom-ticketing">
    <div
      className={`${
        // eslint-disable-next-line
        customClass1 ? customClass1 : ""
      } text-wrap-ellipsis`}
      title={dataUp}
      onClick={() =>
        clickHandler1 &&
        typeof clickHandler1 === "function" &&
        clickHandler1(rowData)
      }
    >
      {dataUp}
    </div>
    <div
      className={`${
        // eslint-disable-next-line
        customClass2 ? customClass2 : ""
      } text-wrap-ellipsis`}
      title={dataDown}
    >
      {dataDown}
    </div>
  </div>
);

const goToCreateTicket = (rowData: Object) => {
  // eslint-disable-next-line no-console
  console.log("history", rowData);
  if (!rowData || !rowData.id) {
    return;
  }
  const viewTicketRouteObj = {
    route: `/createTicket/${rowData.id}`,
    zoomuinewroute: true
  };

  navigateToRouteHelper(viewTicketRouteObj, true);
};

export const goToCnOrPrq = (rowData: Object) => {
  // eslint-disable-next-line no-console
  console.log("history", rowData);
  if (!rowData || !rowData.entityId) {
    return;
  }
  if (rowData.entityType === "CN") {
    const cnTrackingRouteObj = {
      route: `trackconsignment/${rowData.entityId}`,
      previousRoute: true
    };
    navigateToRouteHelper(cnTrackingRouteObj, true);
  } else if (rowData.entityType === "PRQ") {
    const prqRouteObj = {
      route: `pickuptracking/${rowData.entityId}`,
      previousRoute: true
    };
    navigateToRouteHelper(prqRouteObj, true);
  }
};

export const getCommentTimeAgentDetails = (row, isDownload) => {
  let { lastAssigneeActionDTO } = row;
  if (!lastAssigneeActionDTO) {
    lastAssigneeActionDTO = {};
  }

  if (isDownload) {
    return `${(lastAssigneeActionDTO.lastAction || "").replace(
      /<\/?[^>]+(>|$)/g,
      ""
    )}, ${lastAssigneeActionDTO.name || ""},  ${
      lastAssigneeActionDTO.createdAt
        ? new Date(lastAssigneeActionDTO.createdAt).toLocaleString()
        : ""
    }`;
  }

  return (
    <div
      className={`l-col ${styles.commentTimeAndAgentDetails}`}
      style={{ lineHeight: "2.5rem" }}
    >
      <div
        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
        dangerouslySetInnerHTML={{
          __html: lastAssigneeActionDTO.lastAction || "__"
        }}
      />
      <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {`${lastAssigneeActionDTO.name || "--"}`}
      </div>
      <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {lastAssigneeActionDTO && lastAssigneeActionDTO.createdAt
          ? new Date(lastAssigneeActionDTO.createdAt).toLocaleString()
          : null}
      </div>
    </div>
  );
};
export const getSLACellObject = (timestamp: number) => {
  const momentTime = moment().valueOf();
  let timeDiff = timestamp - momentTime;
  let remainingOrOverDue;

  if (timeDiff >= 0) {
    remainingOrOverDue = "Remaining";
  } else {
    remainingOrOverDue = "Overdue";
    timeDiff = Math.abs(timeDiff);
  }
  // what's left is seconds
  // const seconds = timeDiff % 60;

  return (
    <div
      className={`${
        remainingOrOverDue === "Overdue"
          ? "table-cell-custom-ticketing-overdue"
          : "table-cell-custom-ticketing"
      } l-col`}
    >
      <div>{getFormattedSLAFromMillis(timeDiff)}</div>
      <div className="">{remainingOrOverDue}</div>
    </div>
  );
};

const formatPriority = priority => {
  if (priority === "HIGH") {
    return "(High)";
  }
  if (priority === "MEDIUM") {
    return "(Medium)";
  }
  return null;
};

export const getSLA = escalateAt => {
  const momentTime = moment().valueOf();
  const timeDiff = escalateAt - momentTime;
  return getFormattedSLAFromMillis(timeDiff);
};

export const ticketDashboardTableConfig = {
  columns: [
    {
      Header: "Ticket ID",
      accessor: "id",
      maxWidth: 100,
      Cell: (row: Object) => {
        if (row.original.status === "INCOMPLETE") {
          return getTicketDashboardCellObject(
            row.original.id,
            formatPriority(row.original.priority),
            row.original,
            goToCreateTicket,
            "cn-highlight"
          );
        }
        return getTicketDashboardCellObject(
          row.original.id,
          formatPriority(row.original.priority),
          row.original,
          goToViewTicket,
          "cn-highlight"
        );
      },
      sortMethod: (a, b) => (a > b ? 1 : -1)
    },
    {
      Header: "Issue type",
      accessor: "typeName",
      maxWidth: 350
    },
    {
      Header: "Subject",
      accessor: "title",
      width: 200,
      maxWidth: 350
    },
    {
      Header: "Requestor",
      accessor: "requestorEmail",
      maxWidth: 400,
      Cell: (row: Object) =>
        row.original.requestorEmail ? (
          <div className="text-wrap-ellipsis">
            {row.original.requestorEmail}
          </div>
        ) : (
          "-"
        )
    },
    {
      Header: "Owner",
      accessor: "ownerName",
      width: 200,
      maxWidth: 250,
      Cell: (row: Object) =>
        row.original.ownerName ? (
          <div className="text-wrap-ellipsis">{row.original.ownerName}</div>
        ) : (
          "-"
        )
    },
    {
      Header: "Severity",
      accessor: "severity",
      maxWidth: 100,
      Cell: (row: Object) =>
        row.original.severity ? (
          <div className="text-wrap-ellipsis">
            {row.original.severity ? row.original.severity : ""}
          </div>
        ) : (
          "-"
        )
    },
    {
      Header: "Status",
      accessor: "status",
      maxWidth: 200,
      Cell: (row: Object) => <div>{row.original.status.replace("_", " ")}</div>
    },
    {
      Header: "SLA",
      accessor: "escalateAt",
      maxWidth: 300,
      formatter: (row: Object) => getSLA(row.escalateAt),
      Cell: (row: Object) => {
        if (row.original.status === "CLOSED") {
          return "-";
        }
        return getSLACellObject(row.original.escalateAt);
      }
    },
    {
      Header: "Last Action",
      accessor: "lastaction",
      maxWidth: 300,
      formatter: (row: Object) => getCommentTimeAgentDetails(row, true),
      Cell: (row: Object) => getCommentTimeAgentDetails(row.original)
    }
  ],
  className: "zoomTableLegacyWrapper",
  noDataText: "No tickets found",
  minRows: 7,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: "calc(100vh - 28rem)" }
};

export const ticketCsvDownloadExtraFields = {
  columns: [
    {
      Header: "Ticket Creation Date",
      accessor: "createdAt",
      maxWidth: 300,
      formatter: (row: Object) => getFormattedDateAndTime(row.createdAt),
      Cell: (row: Object) => (
        <div>{getFormattedDateAndTime(row.original.createdAt)}</div>
      )
    },
    {
      Header: "Entity Type",
      accessor: "entityType",
      maxWidth: 300,
      formatter: (row: Object) => row.entityType,
      Cell: (row: Object) => <div>{row.original.entityType}</div>
    },
    {
      Header: "Entity Number",
      accessor: "entityId",
      formatter: (row: Object) => row.entityId,
      Cell: (row: Object) => <div>{row.original.entityId}</div>
    }
  ]
};

export const pageObj = {
  pageName: "Pace Dashboard",
  betaPage: false
};

export const ticketDashboardTabs = {
  assignedToMe: {
    label: "Assigned to me",
    countAccessor: "assignedToTicket",
    apiEndPoint: "getAssignedTickets"
  },
  createdByMe: {
    label: "Created by me",
    countAccessor: "createdByTicket",
    apiEndPoint: "getCreatedTickets"
  },
  unassignedGroupTickets: {
    label: "My Group Tickets",
    countAccessor: "unassignedTicket",
    apiEndPoint: "getUnassignedTickets"
  },
  ccedToMe: {
    label: "CCed to me",
    countAccessor: "ccedTicket",
    apiEndPoint: "getCcedTickets"
  },
  escalatedTickets: {
    label: "Escalated to Me",
    countAccessor: "escalatedTickets",
    apiEndPoint: "getEscalatedTickets"
  },
  allMyBuTickets: {
    label: "All my BU Tickets",
    countAccessor: "buTickets",
    apiEndPoint: "getBuTickets"
  }
};

export const createPRQRouteObj = {
  route: "createpickup",
  previousRoute: true
};

export const createTicketRouteObj = {
  route: "/createticket",
  zoomuinewroute: true
};

export const buSettingsRouteObj = {
  route: "/buSettings",
  zoomuinewroute: true
};

export const categorySettingsRouteObj = {
  route: "/categorySettings",
  zoomuinewroute: true
};

export const resolverGroupSettingsRouteObj = {
  route: "/resolverGroup",
  zoomuinewroute: true
};

export const analyticsEventList = {
  render: {
    event_category: "ticketdashboard",
    event_action: "render",
    event_label: "Open Ticket Dashboard"
  },
  change_tab: {
    event_category: "ticketdashboard",
    event_action: "tab_change",
    event_label: "Tab: "
  },
  change_cluster: {
    event_category: "ticketdashboard",
    event_action: "filter",
    event_label: "Cluster: "
  },
  header_search: {
    event_category: "ticketdashboard",
    event_action: "header_search",
    event_label: "Option: "
  },
  change_status: {
    event_category: "ticketdashboard",
    event_action: "change_status",
    event_label: "Option: "
  }
};

export const severityOptions = [
  {
    key: "ONE ( Low )",
    val: "ONE",
    label: "ONE ( Low )",
    value: "ONE"
  },
  {
    key: "TWO ( Medium )",
    val: "TWO",
    label: "TWO ( Medium )",
    value: "TWO"
  },
  {
    key: "THREE ( High )",
    val: "THREE",
    label: "THREE ( High )",
    value: "THREE"
  },
  {
    key: "FOUR ( Partial Outage )",
    val: "FOUR",
    label: "FOUR ( Partial Outage )",
    value: "FOUR"
  },
  {
    key: "FIVE ( Blocker )",
    val: "FIVE",
    label: "FIVE ( Blocker )",
    value: "FIVE"
  }
];

export const getSeverityOptions = (ticketTypeDTO, defaulSeverityOptions) => {
  if (!ticketTypeDTO) {
    return [];
  }
  const severityOrdinalValueMap = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5
  };
  let options = [];
  options = defaulSeverityOptions.filter(
    option =>
      severityOrdinalValueMap[option.val] >=
        severityOrdinalValueMap[ticketTypeDTO.minimumSeverity] &&
      severityOrdinalValueMap[option.val] <=
        severityOrdinalValueMap[ticketTypeDTO.maximumSeverity]
  );
  return options;
};



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/ticketDashboard/ticketDashboardHelper.js